<template>
    <div class="flex flex-1 justify-center">
        <the-loader />
        <main class="overflow-auto relative flex-1 focus:outline-hidden" data-test="content">
            <slot />
        </main>
    </div>
</template>

<script>
import TheLoader from '@/components/the-loader';

export default {
    name:       'LayoutExternal',
    components: {
        TheLoader,
    },
};
</script>
